module.exports = __webpack_public_path__ + "img/paul-pro.7229691a.jpg";